<template>
  <div>
    <div class="input-container">
      <b-row>
        <b-col>
          <p class="modal-text">Do you want to clear all completed tasks in the list? This action cannot be undone.</p>
        </b-col>
      </b-row>
    </div>
    <hr>
    <b-button class="main-input-button" block @click="clearCompletedTasks">Clear completed tasks</b-button>
  </div>
</template>

<script>
  import {db, storage} from "../../../main";
  import {mapGetters} from "vuex";

  export default {
    name: "TaskListClearCompletedTasks",
    data() {
      return {
        toDoListId: null
      }
    },
    methods: {
      clearCompletedTasks() {
        if (this.$route.name === 'Inbox') {
          db
            .collection('inbox_to_do_lists')
            .where('ownerId', '==', this.$store.getters.user.data.id)
            .get()
            .then(querySnapshot => {
              querySnapshot.docs.map(doc => {
                this.toDoListId = doc.id

                db
                  .collection('inbox_to_do_lists/' + this.toDoListId + '/tasks')
                  .where('toDoListId', '==', this.toDoListId)
                  .where('completed', '==', true)
                  .get()
                  .then(querySnapshot => {
                    const taskObject = querySnapshot.docs.map(doc => doc.data())

                    taskObject.forEach(task => {
                      // optional: check if the task has any image attached and delete if the task has any image attached
                      const attachmentObject = task.attachment

                      if (attachmentObject !== null) {
                        const attachment = task.attachment.toString()
                        const attachmentRef = storage.refFromURL(attachment)

                        attachmentRef.delete()
                      }

                      this.deleteTask(task.taskId)
                    })
                  })
              })
            })
        } else if (this.$route.name === 'Personal Task List') {
          db
            .collection('personal_to_do_lists/' + this.toDoListId + '/tasks')
            .where('toDoListId', '==', this.toDoListId)
            .where('completed', '==', true)
            .get()
            .then(querySnapshot => {
              const taskObject = querySnapshot.docs.map(doc => doc.data())

              taskObject.forEach(task => {
                // optional: check if the task has any image attached and delete if the task has any image attached
                const attachmentObject = task.attachment

                if (attachmentObject !== null) {
                  const attachment = task.attachment.toString()
                  const attachmentRef = storage.refFromURL(attachment)

                  attachmentRef.delete()
                }

                this.deleteTask(task.taskId)
              })
            })
        } else if (this.$route.name === 'Collaborative Task List') {
          if (this.collaborativeTaskListSelectedTab === 'All Task') {
            db
              .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
              .where('toDoListId', '==', this.toDoListId)
              .where('completed', '==', true)
              .get()
              .then(querySnapshot => {
                const taskObject = querySnapshot.docs.map(doc => doc.data())

                taskObject.forEach(task => {
                  // optional: check if the task has any image attached and delete if the task has any image attached
                  const attachmentObject = task.attachment

                  if (attachmentObject !== null) {
                    const attachment = task.attachment.toString()
                    const attachmentRef = storage.refFromURL(attachment)

                    attachmentRef.delete()
                  }

                  this.deleteTask(task.taskId)
                })
              })
          } else if (this.collaborativeTaskListSelectedTab === 'My Task') {
            db
              .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
              .where('toDoListId', '==', this.toDoListId)
              .where('completed', '==', true)
              .where('assigneeId', '==', this.$store.getters.user.data.id)
              .get()
              .then(querySnapshot => {
                const taskObject = querySnapshot.docs.map(doc => doc.data())

                taskObject.forEach(task => {
                  // optional: check if the task has any image attached and delete if the task has any image attached
                  const attachmentObject = task.attachment

                  if (attachmentObject !== null) {
                    const attachment = task.attachment.toString()
                    const attachmentRef = storage.refFromURL(attachment)

                    attachmentRef.delete()
                  }

                  this.deleteTask(task.taskId)
                })
              })
          }
        }

        this.hideModal('task-list-option-modal')
      },
      deleteTask(taskId) {
        if (this.$route.name === 'Inbox') {
          db
            .collection('inbox_to_do_lists/' + this.toDoListId + '/tasks')
            .doc(taskId)
            .get()
            .then(doc => {
              doc.ref.delete()
            })
        } else if (this.$route.name === 'Personal Task List') {
          db
            .collection('personal_to_do_lists/' + this.toDoListId + '/tasks')
            .doc(taskId)
            .get()
            .then(doc => {
              doc.ref.delete()
            })
        } else if (this.$route.name === 'Collaborative Task List') {
          db
            .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
            .doc(taskId)
            .get()
            .then(doc => {
              doc.ref.delete()
            })
        }
      },
      hideModal(id) {
        this.$root.$emit('bv::hide::modal', id)
      }
    },
    computed: {
      ...mapGetters([
        "collaborativeTaskListSelectedTab"
      ])
    },
    mounted() {
      if (this.$route.name === 'Personal Task List') {
        this.toDoListId = this.$route.params.personalListId
      } else if (this.$route.name === 'Collaborative Task List') {
        this.toDoListId = this.$route.params.collaborativeListId
      }
    }
  }
</script>

<style scoped>
  .input-container {
    margin-bottom: 1em;
  }

  .modal-text {
    margin-bottom: 0;
  }

  .main-input-button {
    font-weight: bold;
    background-color: #212441;
    padding: 0.5em;
  }

  .main-input-button:hover {
    font-weight: bold;
    background-color: #FFFFFF;
    color: #212441;
    padding: 0.5em;
  }
</style>
